export const PARAMETER_SETTING_FIXTURES = [
    {
        id: 1,
        code: '0045',
        name: 'Alice Johnson',
        created: 20240101,
        updated: 20240601,
        status: 1,
        action: 'view',
        displayOrder: 1,
        keyValue: 'Testing-001',
        showButton: 1,
        // Step 1: Info
        no: 1,
        keyName: 'Parameter Key 1',
        keyDesc: 'Description for parameter key 1',
        // Step 2: Text Fields
        text1: 'Text Field 1',
        text1Visible: true,
        text2: 'Text Field 2',
        text2Visible: true,
        text3: 'Text Field 3',
        text3Visible: false,
        text4: 'Text Field 4',
        text4Visible: true,
        text5: 'Text Field 5',
        text5Visible: true,
        // Step 3: Integer Fields
        intText1: 100,
        intText1Visible: true,
        intText2: 200,
        intText2Visible: true,
        intText3: 300,
        intText3Visible: false,
        intText4: 400,
        intText4Visible: true,
        intText5: 500,
        intText5Visible: true,
        intDesc1: 'Integer Description 1',
        intDesc1Checkbox: true,
        intDesc2: 'Integer Description 2',
        intDesc2Checkbox: false,
        intDesc3: 'Integer Description 3',
        intDesc3Checkbox: true,
        intDesc4: 'Integer Description 4',
        intDesc4Checkbox: false,
        intDesc5: 'Integer Description 5',
        intDesc5Checkbox: true,
        // Step 4: Decimal Fields
        decText1: 10.5,
        decText1Visible: true,
        decText2: 20.75,
        decText2Visible: true,
        decText3: 30.25,
        decText3Visible: false,
        decText4: 40.5,
        decText4Visible: true,
        decText5: 50.75,
        decText5Visible: true
    },
    {
        id: 2,
        code: '0046',
        name: 'Bob Smith',
        created: 20230515,
        updated: 20240310,
        status: 2,
        action: 'view',
        displayOrder: 2,
        keyValue: 'Test-001',
        showButton: 1,
        // Step 1: Info
        no: 2,
        keyName: 'Parameter Key 2',
        keyDesc: 'Description for parameter key 2',
        // Step 2: Text Fields
        text1: 'Sample Text 1',
        text1Visible: true,
        text2: 'Sample Text 2',
        text2Visible: false,
        text3: 'Sample Text 3',
        text3Visible: true,
        text4: 'Sample Text 4',
        text4Visible: true,
        text5: 'Sample Text 5',
        text5Visible: false,
        // Step 3: Integer Fields
        intText1: 10,
        intText1Visible: true,
        intText2: 20,
        intText2Visible: false,
        intText3: 30,
        intText3Visible: true,
        intText4: 40,
        intText4Visible: true,
        intText5: 50,
        intText5Visible: false,
        intDesc1: 'Desc 1',
        intDesc1Checkbox: false,
        intDesc2: 'Desc 2',
        intDesc2Checkbox: true,
        intDesc3: 'Desc 3',
        intDesc3Checkbox: false,
        intDesc4: 'Desc 4',
        intDesc4Checkbox: true,
        intDesc5: 'Desc 5',
        intDesc5Checkbox: false,
        // Step 4: Decimal Fields
        decText1: 1.5,
        decText1Visible: true,
        decText2: 2.75,
        decText2Visible: false,
        decText3: 3.25,
        decText3Visible: true,
        decText4: 4.5,
        decText4Visible: true,
        decText5: 5.75,
        decText5Visible: false
    }
];

export const SUB_PARAMETER_SETTING_FIXTURES = [
    {
        id: 1,
        code: '0045',
        name: 'Alice Johnson',
        created: 20240101,
        updated: 20240601,
        status: 1,
        action: 'view',
        displayOrder: 1,
        keyValue: 'Testing-001',
        showButton: 1
    },
    {
        id: 2,
        code: '0046',
        name: 'Bob Smith',
        created: 20230515,
        updated: 20240310,
        status: 2,
        action: 'view',
        displayOrder: 2,
        keyValue: 'Test-001',
        showButton: 1
    }
];
